import(/* webpackMode: "eager" */ "/vercel/path0/packages/web/app/global-error.tsx");
